var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 203,
    height: 64.283,
    viewBox: "0 0 203 64.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2922",
    "data-name": "Rectangle 2922",
    width: 203,
    height: 64.283,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMC_Logo",
    "data-name": "CMC Logo",
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "translate(0 -29)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M13.134,86.419a5.218,5.218,0,0,0-5.05-3.833c-3.7,0-6,3.012-6,7.193,0,4.5,2.879,7.814,6.246,7.814,1.75,0,3.9-.672,5.4-3.683h.421a18.079,18.079,0,0,1-1.418,3.633c-1.418-.224-2.392.672-5.006.672A7.567,7.567,0,0,1,0,90.276c0-4.828,3.322-8.312,7.951-8.312,2.791,0,3.987,1,4.673,1,.244,0,.355-.075.4-.15h.332l.2,3.609Z",
    transform: "translate(0 -38.002)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M36.587,98.162,30.939,84.9h-.045l-.6,11.2c-.067,1.27.775,1.543,1.772,1.592v.473H27.461v-.473c1.617,0,1.817-.4,1.927-2.663l.532-9.681c.088-1.642.044-2.091-1.329-2.19v-.448h3.345L37.273,95.25l5.316-12.543h3.256v.448c-1.086.1-1.506.124-1.462.97L45.092,95.4c.132,2.289.31,2.289,1.927,2.289v.473H41.326v-.473c1.041,0,2.06-.323,1.972-1.642L42.655,84.9h-.044L37.1,98.162Z",
    transform: "translate(-12.732 -38.347)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M77.762,86.419a5.219,5.219,0,0,0-5.05-3.833c-3.7,0-6,3.012-6,7.193,0,4.5,2.88,7.814,6.246,7.814,1.75,0,3.9-.672,5.4-3.683h.421a18.047,18.047,0,0,1-1.418,3.633c-1.417-.224-2.392.672-5.005.672a7.568,7.568,0,0,1-7.73-7.939c0-4.828,3.323-8.312,7.951-8.312,2.791,0,3.987,1,4.674,1,.243,0,.355-.075.4-.15h.333l.2,3.609Z",
    transform: "translate(-29.964 -38.002)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M28.113,17.4C29.461,10.9,31.192,2.558,31.526.944c.126-.477.136-.625.341-.8.271-.234.672-.14,1.346.02.785.187,1.945.593,1.945.593a20.594,20.594,0,0,1,0,38.621,1.444,1.444,0,0,1-1.856-.854,1.415,1.415,0,0,1-.092-.5,1.449,1.449,0,0,1,.945-1.356A17.67,17.67,0,0,0,36.1,4.364V19.81a1.445,1.445,0,1,1-2.89,0V5.254l-3.857,18.6a1.26,1.26,0,0,1-2.468,0l-3.857-18.6V19.81a1.445,1.445,0,1,1-2.89,0V4.364a17.67,17.67,0,0,0,1.946,32.3,1.446,1.446,0,0,1-1,2.711,20.593,20.593,0,0,1,0-38.621S22.24.348,23.026.162C23.7,0,24.1-.093,24.371.141c.2.177.214.325.34.8.335,1.614,2.067,9.957,3.414,16.458Z",
    transform: "translate(-3.543 0)",
    fill: "#a72228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M102.721,85.452v3.62h4.559v2.313h-4.559v4.592h6.4v2.414h-8.917V83.038h8.917v2.414Z",
    transform: "translate(-46.461 -38.5)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M126.384,101.956,123.87,98.23l-2.514,3.727h-2.85l3.967-5.8-3.665-5.432h2.782l2.3,3.359,2.291-3.359h2.749l-3.64,5.4,4.009,5.834Z",
    transform: "translate(-54.945 -42.065)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M147.277,97.812V90.89a2.328,2.328,0,0,0-.6-1.668,2.048,2.048,0,0,0-1.558-.629,2.383,2.383,0,0,0-1.2.351,2.29,2.29,0,0,0-.867.8v8.065h-2.447V82.417l2.447-.629V87.3a3.517,3.517,0,0,1,2.571-.921,3.856,3.856,0,0,1,3,1.168,4.8,4.8,0,0,1,1.066,3.347v6.915Z",
    transform: "translate(-65.191 -37.921)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M162.879,82.6a1.286,1.286,0,0,1,.983.447,1.63,1.63,0,0,1,0,2.157,1.305,1.305,0,0,1-1.966,0,1.63,1.63,0,0,1,0-2.157,1.286,1.286,0,0,1,.983-.447m-1.257,15.588V89.1h-1.308V86.959h3.754v11.23Z",
    transform: "translate(-74.329 -38.298)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M175.986,88.593q3,0,3,3.42a4.6,4.6,0,0,1-.726,2.885,3,3,0,0,1-2.469.9,1.723,1.723,0,0,1-1.431-.682V89.254a2.025,2.025,0,0,1,1.629-.661m.326,9.419a4.721,4.721,0,0,0,3.787-1.639,6.639,6.639,0,0,0,1.4-4.455,5.757,5.757,0,0,0-1.388-3.984,4.653,4.653,0,0,0-3.648-1.555,3.732,3.732,0,0,0-2.1.639V81.788l-2.414.629v15.6h1.362l.544-.828a3.8,3.8,0,0,0,2.462.828",
    transform: "translate(-79.721 -37.921)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M193.295,82.6a1.286,1.286,0,0,1,.983.447,1.63,1.63,0,0,1,0,2.157,1.305,1.305,0,0,1-1.966,0,1.629,1.629,0,0,1,0-2.157,1.285,1.285,0,0,1,.983-.447m-1.257,15.588V89.1H190.73V86.959h3.755v11.23Z",
    transform: "translate(-88.431 -38.298)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M202.562,90.027h-1.207V87.914h1.207V85.628l2.414-.965v3.251h2.816v2.112h-2.816v4.909a3.119,3.119,0,0,0,.343,1.7,1.36,1.36,0,0,0,1.206.5,2.824,2.824,0,0,0,1.6-.5v2.4a7.076,7.076,0,0,1-2.381.313,2.96,2.96,0,0,1-2.359-.948,3.981,3.981,0,0,1-.824-2.7Z",
    transform: "translate(-93.357 -39.254)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M235.058,98.509l-.647-9.434c-.061-.968-.1-2.111-.1-2.573-.1.506-.284,1.407-.547,2.375l-2.549,9.632h-1.983l-2.327-9.214c-.263-1.012-.526-2.309-.607-2.815,0,.506-.081,1.891-.142,2.837l-.606,9.192h-2.286l1.274-15.217h3.1l2.144,8.62c.324,1.275.445,2.067.526,2.529.061-.462.243-1.429.506-2.485l2.206-8.664h3.1l1.234,15.217Z",
    transform: "translate(-103.515 -38.618)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M258.394,97.538q0,2.367-2.153,2.367-1.6,0-1.6-1.514,0-2.039,2.839-2.04a4.791,4.791,0,0,1,.915.134Zm.8,4.026a1.3,1.3,0,0,0,.942.419,2.479,2.479,0,0,0,.84-.132,1.336,1.336,0,0,0,.661-.705q-.829-.575-.828-2.814v-2.4q0-3.253-1.1-4.418a4.541,4.541,0,0,0-3.451-1.167,6.425,6.425,0,0,0-2.96.637l.52,2.045a4.59,4.59,0,0,1,2.255-.5q2.286,0,2.286,1.978a3.645,3.645,0,0,0-1-.168,5.82,5.82,0,0,0-3.8,1.1,3.739,3.739,0,0,0-1.338,3.055,3.4,3.4,0,0,0,.95,2.578,3.64,3.64,0,0,0,2.622.908,4.023,4.023,0,0,0,1.692-.372,2.352,2.352,0,0,0,1.139-.96,2.181,2.181,0,0,0,.563.913",
    transform: "translate(-116.943 -41.891)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M279.329,101.782V95.289a3.465,3.465,0,0,0-.507-2.1,1.959,1.959,0,0,0-1.657-.661,2.376,2.376,0,0,0-1.124.326,2.64,2.64,0,0,0-.935.807v8.119h-2.414V90.552h1.729l.45,1.048a3.455,3.455,0,0,1,2.9-1.249,3.69,3.69,0,0,1,2.9,1.2,4.859,4.859,0,0,1,1.068,3.347v6.884Z",
    transform: "translate(-126.432 -41.891)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M298.012,97.538q0,2.367-2.153,2.367-1.6,0-1.6-1.514,0-2.039,2.839-2.04a4.79,4.79,0,0,1,.915.134Zm.8,4.026a1.3,1.3,0,0,0,.942.419,2.479,2.479,0,0,0,.84-.132,1.336,1.336,0,0,0,.661-.705q-.829-.575-.828-2.814v-2.4q0-3.253-1.1-4.418a4.541,4.541,0,0,0-3.451-1.167,6.425,6.425,0,0,0-2.96.637l.519,2.045a4.6,4.6,0,0,1,2.256-.5q2.286,0,2.286,1.978a3.645,3.645,0,0,0-1-.168,5.82,5.82,0,0,0-3.8,1.1,3.739,3.739,0,0,0-1.338,3.055,3.4,3.4,0,0,0,.95,2.578,3.64,3.64,0,0,0,2.622.908,4.025,4.025,0,0,0,1.692-.372,2.352,2.352,0,0,0,1.139-.96,2.176,2.176,0,0,0,.563.913",
    transform: "translate(-135.312 -41.891)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M314.228,92.454a1.746,1.746,0,0,1,1.356-.57,1.6,1.6,0,0,1,1.282.592,2.174,2.174,0,0,1,.5,1.447,2.567,2.567,0,0,1-.467,1.627,1.576,1.576,0,0,1-1.314.591,1.689,1.689,0,0,1-1.367-.607,2.43,2.43,0,0,1-.507-1.611,2.1,2.1,0,0,1,.518-1.469m1.382,13.14a5.866,5.866,0,0,0,3.4-.964,3.046,3.046,0,0,0,1.408-2.652q0-3.054-3.508-3.055a5.815,5.815,0,0,0-1.2.151,5.49,5.49,0,0,1-1,.151q-.659,0-.658-.421,0-.242.43-.469a2.175,2.175,0,0,1,.5-.226l.387.078a4.877,4.877,0,0,0,.7.065,3.536,3.536,0,0,0,2.705-1.154,4.346,4.346,0,0,0,1.073-3.082,4.445,4.445,0,0,0-.6-2.339l1.167-.919L318.737,89.1l-.943,1.206a4.379,4.379,0,0,0-2.316-.569,4.135,4.135,0,0,0-3,1.183,3.992,3.992,0,0,0-1.215,2.99,4.081,4.081,0,0,0,1.768,3.542,2.537,2.537,0,0,0-.958.786,1.783,1.783,0,0,0-.408,1.09q0,1.941,2.484,1.94a10.5,10.5,0,0,0,1.2-.1,10.539,10.539,0,0,1,1.206-.1q1.483,0,1.483.978a1.006,1.006,0,0,1-.674.906,3.992,3.992,0,0,1-4.517-.945l-1.514,2.057a6.687,6.687,0,0,0,4.28,1.53",
    transform: "translate(-144.316 -41.311)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M334.738,92.53q2.259,0,2.51,2.447h-5.062q.5-2.447,2.552-2.447m4.924,2.972a5.2,5.2,0,0,0-1.361-3.7,4.99,4.99,0,0,0-7.223.191,6.1,6.1,0,0,0-1.507,4.292,6,6,0,0,0,1.369,4.193,4.8,4.8,0,0,0,3.731,1.5,5.606,5.606,0,0,0,3.783-1.106l-.929-2.011a3.208,3.208,0,0,1-2.5.939,2.888,2.888,0,0,1-2.093-.749,3.02,3.02,0,0,1-.851-2.1h7.366a7.634,7.634,0,0,0,.21-1.452",
    transform: "translate(-152.805 -41.891)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M357.375,93a2.349,2.349,0,0,0-1.419-.469,1.881,1.881,0,0,0-1.492.829,3.174,3.174,0,0,0-.652,2.024v6.4H351.4V90.552h2.414v1.039a3.293,3.293,0,0,1,2.69-1.24,3.652,3.652,0,0,1,1.9.408Z",
    transform: "translate(-162.924 -41.891)",
    fill: "#635d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M364.953,101.051l.862-2.085a3.647,3.647,0,0,0,2.453.939q1.41,0,1.411-1.09a1.389,1.389,0,0,0-.426-1.048A6.4,6.4,0,0,0,367.6,96.8q-2.679-1.2-2.68-3.372a2.729,2.729,0,0,1,1.023-2.267,4.082,4.082,0,0,1,2.617-.812,6.156,6.156,0,0,1,3.031.785l-.691,2.031a3.113,3.113,0,0,0-2.2-.737q-1.268,0-1.267,1.09a1,1,0,0,0,.419.776,8.521,8.521,0,0,0,1.782.928,4.556,4.556,0,0,1,1.96,1.409,3.323,3.323,0,0,1,.6,2,3.032,3.032,0,0,1-1.068,2.455,4.389,4.389,0,0,1-2.91.9,6.087,6.087,0,0,1-1.658-.183,7.8,7.8,0,0,1-1.6-.749",
    transform: "translate(-169.193 -41.891)",
    fill: "#635d63"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e51c68415b4ad5b90ff2713b6ca08309.svg";
export { ForwardRef as ReactComponent };